import moment from 'moment'
import ucFirst from './ucFirst'

export default function readableMonth(date, capitalize = true) {
  if (!date) return ''
  const readableMonth = moment(date).locale('fr').format('MMMM YYYY')
  if (capitalize) return ucFirst(readableMonth)
  return readableMonth
}
